import { render, staticRenderFns } from "./MyZs6.vue?vue&type=template&id=37d81913&scoped=true&"
import script from "./MyZs6.vue?vue&type=script&lang=js&"
export * from "./MyZs6.vue?vue&type=script&lang=js&"
import style0 from "./MyZs6.vue?vue&type=style&index=0&id=37d81913&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d81913",
  null
  
)

export default component.exports